import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { MappedUserGroup } from '../../../features/organization/enterprise/types';
import { overrideOrganizationHeader } from '@cast/api-client';
import { useOrganizations } from '@cast/shared-organization-context-data-access';
import { getUserGroupsQueryKey } from 'hooks/queries/enterprise';

type UseBatchDeleteUserGroupsMutationArgs = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useBatchDeleteUserGroupsMutation = ({
  onSuccess,
  onError,
}: UseBatchDeleteUserGroupsMutationArgs) => {
  const queryClient = useQueryClient();
  const { enterpriseOrgId } = useOrganizations();

  return useMutation({
    mutationFn: (userGroups: MappedUserGroup[]) => {
      const requests = userGroups.map((userGroup) => ({
        id: userGroup.id!,
        organizationId: userGroup.organizationId!,
      }));

      return apiClient.enterprises.batchDeleteUserGroups(
        {
          enterpriseId: enterpriseOrgId!,
          batchDeleteEnterpriseGroupsRequest: {
            enterpriseId: enterpriseOrgId!,
            requests,
          },
        },
        {
          headers: overrideOrganizationHeader(enterpriseOrgId),
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getUserGroupsQueryKey({
          enterpriseOrgId: enterpriseOrgId!,
        }),
      });

      onSuccess?.();
    },
    onError,
  });
};
